/**
 * Allow to communicate with legacy front (jQuery)
 */
export enum Events {
  DIFFUSER_COUR = "DIFFUSER_COUR", // Open the share panel
  DUPLICATE_COUR_THUMBNAIL = "DUPLICATE_COUR_THUMBNAIL", // Dupplicate a speach
  MOUNT_VUE_COMPONENT = "MOUNT_VUE_COMPONENT",// Mount a vue component
  OPEN_POPIN_IMAGE = "OPEN_POPIN_IMAGE",  // Open the panel to modify an image
  AFFICHER_EDITION_CHAPITRE = "AFFICHER_EDITION_CHAPITRE", // Show the chapter Editing page
  AFFICHER_CHOIX_TYPE_CHAPITRE = 'AFFICHER_CHOIX_TYPE_CHAPITRE',// Show the choice of type of media
  RAFRAICHIR_PLAN_CHAPITRE = "RAFRAICHIR_PLAN_CHAPITRE", // Refresh the section of the chapter to refresh the validation point
  RAFRAICHIR_PLAN_COUR = "RAFRAICHIR_PLAN_COUR", // Refresh the whole speach plan (legacy _refreshCour<id> handler)
  RAFRAICHIR_QUIZZ_QUESTION = "RAFRAICHIR_QUIZZ_QUESTION",
  RAFRAICHIR_QUIZZ_NB_QUESTIONS_CHOISIES = "RAFRAICHIR_QUIZZ_NB_QUESTIONS_CHOISIES", // Refresh the exam quiz nb random questions to display slider.
  NEW_KIND_OF_QUESTION_UPDATED="NEW_KIND_OF_QUESTION_UPDATED", // lorsque les questions de types (fill in the blanks, matching, ou sorting sont modifiées)
  SELECT_OLD_VIDEO_UI_CHAPTER = "SELECT_OLD_VIDEO_UI_CHAPTER", // Ask to switch to old chapter editing instead of WeetChaptre.vue
  UPDATE_SHARABLE_SPEACH_LINKS = "UPDATE_SHARABLE_SPEACH_LINKS",
  RESET_SHARABLE_SPEACH_LINKS = "RESET_SHARABLE_SPEACH_LINKS",
  STAT_START = "STAT_START", // trigger stats counter for the current chapter
  FIN_EDITION_QUIZZ_INFORMATION = "FIN_EDITION_QUIZZ_INFORMATION",
  FIN_EDITION_QUIZZ_CORRECTION = "FIN_EDITION_QUIZZ_CORRECTION",

  // VIDEO PLAYER
  VIDEO_AUDIO_TRACK_SELECTED = "VIDEO_AUDIO_TRACK_SELECTED",
  RESET_AUDIO_TRACK = "RESET_AUDIO_TRACK",
  SELECT_AUDIO_TRACK = 'SELECT_AUDIO_TRACK',
  VIDEO_PLAYING = "VIDEO_PLAYING",
  VIDEO_READY = "VIDEO_READY",
  VIDEO_PAUSING = "VIDEO_PAUSING",
  VIDEO_ENDED = "VIDEO_ENDED",
  LOAD_ETAPE = "LOAD_ETAPE",
  UNLOAD_ETAPE="UNLOAD_ETAPE",
  REFRESH_ETAPE="REFRESH_ETAPE",

  // PLAN PANEL / LEGACY PASTILLES & BUTTONS REFRESH
  QUIZZ_COMPLETED = "QUIZZ_COMPLETED",
  CONFIRM_SIMPLE_QUIZ_COMPLETION = "CONFIRM_SIMPLE_QUIZ_COMPLETION",

  // DUE DATE SETTINGS
  BADGE_SET = "BADGE_SET",
  BADGE_UNSET = "BADGE_UNSET",
  DUE_DATE_EXPIRED_SET = "DUE_DATE_EXPIRED_SET",
  DUE_DATE_EXPIRED_UNSET = "DUE_DATE_EXPIRED_UNSET",

  // GENERATE AI AUDIO FROM TEXT
  SAVE_AUDIO_FROM_TEXT = "SAVE_AUDIO_FROM_TEXT",
  CLOSE_AI_AUDIO_POPIN = "CLOSE_AI_AUDIO_POPIN",

  // SCORM EXPORT
  DISPLAY_SCORM_EXPORT_DIALOG = "DISPLAY_SCORM_EXPORT_DIALOG",
  SAVE_EXAM_QUIZ_SCORM_SCORE = "SAVE_EXAM_QUIZ_SCORM_SCORE",

  // ANONYMOUS WORKFLOW
  ANONYMOUS_APPROVERS_UPDATED = "ANONYMOUS_APPROVERS_UPDATED",

  NEXT_ETAPE = "NEXT_ETAPE",
  REFRESH_FULL_TRANSLATION = "REFRESH_FULL_TRANSLATION",
}
